import { MobileAppsLinks, UserContactInfoApiType } from './common.types'

export const CONTACT_INFO_KEY = 'contact-info'

type Nullable<T> = {
  [K in keyof T]: T[K] | null | undefined
}

type MobileAppsLinksRaw = Nullable<MobileAppsLinks>

type UserContactInfoRaw = Nullable<
  Omit<UserContactInfoApiType, 'mobileAppsLinks'>
> & {
  mobileAppsLinks?: MobileAppsLinksRaw | null
}

const isMobileAppsLinks = (
  value: MobileAppsLinksRaw | null | undefined
): value is MobileAppsLinks => {
  if (!value || typeof value !== 'object') {
    return false
  }

  return (
    typeof value.appGallery === 'string' &&
    typeof value.appStore === 'string' &&
    typeof value.googlePlay === 'string' &&
    typeof value.ruStore === 'string'
  )
}

/**
 * maintenanceMode намеренно не проверяется: если бэк его не пришлёт,
 * кэш всё равно должен остаться валидным, значение нормализуется ниже.
 */
const isUserContactInfo = (
  value: UserContactInfoRaw | null | undefined
): value is UserContactInfoRaw &
  Omit<UserContactInfoApiType, 'maintenanceMode'> => {
  if (!value || typeof value !== 'object') {
    return false
  }

  return (
    typeof value.agreementLink === 'string' &&
    typeof value.consentLink === 'string' &&
    typeof value.contactEmail === 'string' &&
    typeof value.contactPhone === 'string' &&
    typeof value.privacyLink === 'string' &&
    typeof value.promoLink === 'string' &&
    isMobileAppsLinks(value.mobileAppsLinks)
  )
}

export const getContactInfoFromStorage = ():
  | UserContactInfoApiType
  | undefined => {
  try {
    const raw = window.localStorage.getItem(CONTACT_INFO_KEY)

    if (!raw) {
      return undefined
    }

    const parsed: UserContactInfoRaw = JSON.parse(raw)

    return isUserContactInfo(parsed)
      ? { ...parsed, maintenanceMode: Boolean(parsed.maintenanceMode) }
      : undefined
  } catch {
    return undefined
  }
}

export const setContactInfoToStorage = (
  contactInfo: UserContactInfoApiType
): void => {
  try {
    window.localStorage.setItem(CONTACT_INFO_KEY, JSON.stringify(contactInfo))
  } catch {
    return undefined
  }
}
